import { resolveCountryCode } from './domain';
import { getSiteName, isSeOcelot } from './domain';

type CountryCode = 'se' | 'fi' | 'dk' | 'no';

interface CountryOptions extends Partial<Record<CountryCode, Modules>> {}

const PREBID_SCRIPT = {
  se: 'https://micro.rubiconproject.com/prebid/dynamic/13012.js',
  fi: 'https://micro.rubiconproject.com/prebid/dynamic/13046.js',
  dk: 'https://micro.rubiconproject.com/prebid/dynamic/15518.js',
  no: '',
};

let countryModules: CountryOptions = {};

export const getModules = (): Modules => {
  const countryCode = resolveCountryCode() as CountryCode;

  if (countryModules[countryCode]) return countryModules[countryCode];

  let modules: Modules = {};
  const isSeOcelotSite = isSeOcelot();
  modules.prebidScript = PREBID_SCRIPT[countryCode];

  switch (countryCode) {
    case 'se':
      modules = {
        ...modules,
        useStats: true,
        useVideoStats: true,
        useLimitedAds: true,
        useGrowthbook: true,
        useSeenthis: true,
        useGLazyLoad: ['responsive_1', 'top_ad'],
        useDivModificationsOnMainCat: true,
        usePrevidVideo: true,
        usePlacementObserver: true,
        useSecondArticle: isSeOcelotSite,
        useLoadDMByAdsLib: isSeOcelotSite,
        usePlacementCheck: isSeOcelotSite,
      };
      break;
    case 'no':
      break;
    case 'dk':
      modules = {
        ...modules,
        useLimitedAds: true,
        useSeenthis: true,
        usePlacementObserver: true,
        useLoadDMByAdsLib: true,
        useGLazyLoad: ['responsive_1', 'top_ad'],
        usePlacementCheck: true,
        useStats: true,
        useVideoStats: true,
      };
      break;
    case 'fi':
      modules = {
        ...modules,
        usePlacementObserver: true,
        useLimitedAds: true,
        useStats: true,
        useVideoStats: true,
        useGLazyLoad: ['responsive_1', 'top_ad'],
      };
      break;
  }

  countryModules[countryCode] = modules;

  return modules;
};
